module.exports = __webpack_public_path__ + "img/female8.39395c35.jpg";